export default __webpack_public_path__ + "static/media/bg-flow-3.c62019d6.png";